import {FetchImageRequestParams} from "../../../infrastructure/models/params/fetch-image-request-params";
import {IMAGE_DEFAULT_FORMATS, THEME} from "../../../core/app/consts";

export class NewsFetchImageRequestParams extends FetchImageRequestParams {
  url: String;

  constructor(url: String, width: Number, height: Number) {
    super(width, height);

    this.url = url;
    this.ratio = 2;
  }

  get fullUrl(): String {
    return this.url;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.JPG;
  }

  get defaultImage() {
    return this.theme === THEME.LIGHT ? 'ic_dashboard_video_placeholder_light.png' : 'ic_dashboard_video_placeholder_2.png';
  }

  get params(): * {
    return `${super.params},d_WebSite:AssetsSVGNewBrand:Logo:${this.defaultImage}`;
  }
}
